import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import ShopTab from "@/components/ShopTab";

// Full-page Pricing — Section 8. Replaces the popup UpgradeSheet as the destination
// for every main "Upgrade Plan" entry point (header tier badge, Profile menu,
// Settings "Your Plan"). UpgradeWallModal's own CTA also lands here.
export default function PricingPage() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-slate-50 text-slate-900 dark:bg-charcoal dark:text-white" data-testid="pricing-page">
      <header className="sticky top-0 z-10 border-b border-slate-200 bg-white/90 pt-[env(safe-area-inset-top)] backdrop-blur-xl dark:border-hairline dark:bg-charcoal/90">
        <div className="mx-auto flex h-16 max-w-6xl items-center gap-3 px-4 md:px-6">
          <button onClick={() => navigate("/app")} data-testid="pricing-back-btn" aria-label="Back" className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-slate-200 text-slate-600 hover:bg-slate-100 dark:border-white/10 dark:text-zinc-300 dark:hover:bg-white/10">
            <ArrowLeft className="h-4 w-4" strokeWidth={2.5} />
          </button>
          <span className="text-sm font-black tracking-tighter">Snaggedify <span className="font-bold text-slate-400 dark:text-zinc-500">by Cheapify</span></span>
        </div>
      </header>
      <main className="mx-auto max-w-6xl px-4 py-8 md:px-6">
        <ShopTab />
      </main>
    </div>
  );
}
